import { render } from "./policy-details.vue?vue&type=template&id=faab5b46&scoped=true"
import script from "./policy-details.vue?vue&type=script&lang=js"
export * from "./policy-details.vue?vue&type=script&lang=js"

import "./policy-details.vue?vue&type=style&index=0&id=faab5b46&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faab5b46"]])

export default __exports__